function getSchemaName(path) {
  if (!path) {
    return "";
  }
  if (typeof path !== "string") {
    return "";
  }
  return path
    ?.split("&")?.[0]
    ?.split("/")
    ?.map(seg => seg.split(".")?.[0])
    ?.join("/");
}

export default getSchemaName;
